import { lazily } from "react-lazily";

import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { UsersSettingsRoute } = lazily(() => import("./UsersSettingsRoot"));

/** The /settings/access-control/users index route: see UsersSettingsRoot. */
export const usersSettingsRoute: PreloadingRouteProps = {
  element: <UsersSettingsRoute />,
  loader: lazyRouteLoader({
    load: () =>
      import("./usersSettingsPreload").then((module) =>
        module.createUsersSettingsLoader(),
      ),
    warm: () => import("./UsersSettingsRoot"),
  }),
  // The directory keeps itself up to date while it is mounted: a search, a
  // page or a change of grouping is written to the URL and handled in place,
  // so none of them needs the loader to run again.
  shouldRevalidate: () => false,
};
